import { spawn } from 'redux-saga/effects';
import { authSaga } from './reducers/auth/saga';
import { userSaga } from './reducers/user/saga';
import { shopsSaga } from './reducers/shops/saga';
import { hscodesWatcher } from './reducers/hscodes/saga';
import { goodsSaga } from './reducers/goods/saga';
import { classificationsSaga } from './reducers/classifications/saga';

export function* rootSaga() {
	yield spawn(authSaga);
	yield spawn(userSaga);
	yield spawn(shopsSaga);
	yield spawn(hscodesWatcher);
	yield spawn(goodsSaga);
	yield spawn(classificationsSaga);
}
